import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Tags from '../components/tags';
import Social from '../components/social';
import "./about.css";

import { StaticQuery } from "gatsby"
import { graphql } from "gatsby"
import Search from "../components/search"


const AboutPage = () => (
  <>
      <br/>
    <h4
    className="title"
    >CERCA</h4>
    <div style={{
      width: '100%'
    }}>
    <StaticQuery
    query={graphql`
      query SearchIndexQuery {
        siteSearchIndex {
          index
        }
      }
    `}
    render={data => (
      <header>
        <Search searchIndex={data.siteSearchIndex.index} />
      </header>
    )}
  />



    </div>
    </>
)

export default AboutPage
